import styled, { css } from 'styled-components';
import { px2rem, mq } from '../../../../stylesheets/tools';

const backgroundColors = {
  ressources: {
    default: '#9770C8',
    dark: '#64389A'
  },
  agriculture: {
    default: '#A6DD89',
    dark: '#6AA349'
  },
  work: {
    default: '#E26372',
    dark: '#B04B57'
  },
  energy: {
    default: '#AD7496',
    dark: '#92577A'
  },
  nutrition: {
    default: '#45A88F',
    dark: '#308D76'
  },
  health: {
    default: '#EE9E77',
    dark: '#EA7137'
  },
  mobility: {
    default: '#F3C85E',
    dark: '#D39908'
  },
  city: {
    default: '#117D94',
    dark: '#0D6477'
  },
  democracy: {
    default: '#D1578D',
    dark: '#8E3B60'
  }
};

const StyledEducationNavBg = styled.div`
  height: ${px2rem('140px')};
  width: 100%;
  clip-path: polygon(100% 0, 100% calc(100% - 10px), 95% 100%, 0 calc(100% - 20px), 0 0);

  ${({ overlap }) =>
    overlap &&
    css`
      position: absolute;
      z-index: 2;
    `};

  ${mq('m')} {
    height: ${px2rem('160px')};
    clip-path: polygon(100% 0, 100% calc(100% - 40px), 95% 100%, 0 calc(100% - 60px), 0 0);
  }

  ${({ category }) =>
    category
      ? css`
          background-color: ${backgroundColors[category]?.default || 'inherit'};
        `
      : css`
          background: black;
        `}
`;

export default StyledEducationNavBg;
